
        <div class="map-container">
           
                 <app-flight-list-map #flightlistmap [supervision]="supervision" [autoLoad]="false" (flightClickedEvent)="flightClickedEventHandler($event)" ></app-flight-list-map>   
                    
        </div>

        <div class="tab-container">
            <app-flight-tab [supervision]="supervision" (flightSelectedEvent)="flighttab_flightSelectedEventHandler($event)"></app-flight-tab>
        </div>

